<template>
  <div class="evaluating">
    <!-- logo图 -->
    <div class="logo">
      <img src="../assets/image/list_logo.png" alt />
    </div>
    <!-- zw -->
    <img src="../assets/image/evaluating_bj.jpg" v-show="false" @load="lazyImg" />
    <!-- gif -->
    <div class="gifBox" v-if="gifdis">
      <img src="../assets/image/loading2.gif" class="gif" />
    </div>
    <div class="evalCon">
      <a href="http://article.photofans.cn/article-54890-1.html" target="_blank">
        <div class="evalCon_auto">
          <div class="leftCon">
            <div>
              <img src="../assets/image/evaluating_img1.jpg" />
            </div>
            <div>
              <img src="../assets/image/evaluating_img2.jpg" />
            </div>
            <div>
              <img src="../assets/image/evaluating_img3.jpg" />
            </div>
          </div>
          <div class="rightCon">
            <div class="hov">
              <img src="../assets/image/evaluating_img4.jpg" />
            </div>
            <div class="hov">
              <img src="../assets/image/evaluating_img5.jpg" />
            </div>
            <div>
              <img src="../assets/image/evaluating_img7.jpg" />
            </div>
            <div class="hov">
              <img src="../assets/image/evaluating_img19120601.jpg" />
            </div>
          </div>
        </div>
      </a>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      gifdis: true
    };
  },
  methods: {
    lazyImg() {
      setTimeout(() => {
        this.gifdis = false;
      }, 1000);
    }
  }
};
</script>
<style scoped>
.evaluating {
  float: left;
  width: 100%;
  height: 100%;
}

.gifBox {
  position: fixed;
  width: 100%;
  height: 100%;
  background: #0c0c0c;
  z-index: 99999999;
}

.gif {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 800px;
}

.evalCon {
  float: left;
  width: 100%;
  height: 100%;
  background: url(../assets/image/evaluating_bj.jpg) no-repeat center;
  background-size: cover;
}

.evalCon_auto {
  position: absolute;
  width: 1300px;
  height: 662px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
}

.leftCon {
  float: left;
  width: 589px;
  height: 100%;
  cursor: pointer;
  background: transparent;
}

.leftCon div {
  float: left;
  overflow: hidden;
}

.leftCon div:hover img {
  transform: scale(1.05);
}

.leftCon div img {
  float: left;
  width: 100%;
  transition: all 0.3s;
}

.leftCon div:nth-child(1) {
  width: 310px;
  height: 662px;
}

.leftCon div:nth-child(2) {
  float: right;
  width: 268px;
  height: 201px;
}

.leftCon div:nth-child(3) {
  float: right;
  margin-top: 10px;
  width: 268px;
  height: 451px;
}

.rightCon {
  float: right;
  width: 702px;
  height: 100%;
  background: transparent;
}

.rightCon div {
  float: left;
  overflow: hidden;
}

.rightCon div img {
  float: right;
  width: 100%;
  transition: all 0.3s;
}

.rightCon div.hov:hover img {
  transform: scale(1.05);
}

.rightCon div:nth-child(1) {
  width: 199px;
  height: 300px;
}

.rightCon div:nth-child(2) {
  float: right;
  width: 493px;
  height: 300px;
}

.rightCon div:nth-child(3) {
  margin-top: 10px;
  float: left;
  width: 477px;
  height: 352px;
}

.rightCon div:nth-child(4) {
  margin-top: 10px;
  float: right;
  width: 215px;
  height: 352px;
}

@media screen and (max-width: 1366px) {
  .evalCon_auto {
    height: 450px;
    overflow-y: auto;
  }
}
</style>